export function globalIdGenerator(prefix = '') {
  let index = 0;
  // eslint-disable-next-line
  return () => `Wpds-${prefix}-${(index += 1)}`;
}
